module.exports = __webpack_public_path__ + "img/report.62e89e17.png";